// extracted by mini-css-extract-plugin
module.exports =  {"nowrap":"_33974c2b58--nowrap--QbNay","wrap":"_33974c2b58--wrap--UqD6F"};